import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';
import { addOnSchema } from './add-on';
import { mapUpdateFrequencySchema } from './map-update-frequency.schema';

export const productAllocationSchema = z.object({
  productId: z.number().min(1),
  addons: z.array(addOnSchema).nullable().optional(),
  productName: z.string().min(1),
  totalUsers: z.number(),
  allocatedLicenses: z.number(),
  assignedLicenses: z.number(),
  activatedLicenses: z.number(),
  enabled: z.boolean(),
  expirationDate: coercedDate.nullable(),
  mapUpdateFrequency: mapUpdateFrequencySchema.optional(),
});

export type ProductAllocation = z.infer<typeof productAllocationSchema>;
